var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-static"},[_c('div',{staticClass:"attatch-to-cursor",attrs:{"id":"attatched-element-to-cursor"}},[_c('flux-clipboard-middleware-display',{attrs:{"middlewares":_vm.middlewares}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }